import { useRef } from 'react';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { useEnteredView } from '@fiverr-private/hooks';
import { reportContactButtonImpression } from '../../utils/contactSeller';

export interface UseContactButtonImpressionOptions {
    elementType: string;
    checkRecentInteractions: () => Promise<boolean>;
}

type ContactSellerTargetType = 'inbox' | 'ask_a_question_drawer' | 'ai_brief_drawer';

export const useContactButtonImpression = ({
    elementType,
    checkRecentInteractions,
}: UseContactButtonImpressionOptions) => {
    const { biEvents } = useGigPageContext();
    const observableRef = useRef<HTMLDivElement>(null);
    const resolveElementName = async (): Promise<ContactSellerTargetType> => {
        const hadRecentInteractions = await checkRecentInteractions();
        return hadRecentInteractions ? 'inbox' : 'ask_a_question_drawer';
    };

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: async () => {
            reportContactButtonImpression({
                biEvents,
                params: { elementType, elementName: await resolveElementName() },
            });
        },
    });

    return observableRef;
};
